
import { formatWaiverStatus } from "./helper_fns"
import { Link } from "react-router-dom";

const WaiverHeader = ({ waiver }) => {

    if (!waiver) return null;

    return (
        <div className="bg-white rounded-xl border p-5 mb-4">
            <div className="flex justify-between items-center">

              <div>
                <h1 className="text-2xl font-semibold">
                  {waiver?.name}
                </h1>

                <span className="inline-flex mt-3 px-3 py-1 rounded-full bg-yellow-100 text-yellow-800 text-sm">
                  {formatWaiverStatus(waiver.waiverStatus)}
                </span>
              </div>

              <div className="text-right">
                <div className="text-sm text-muted-foreground">
                  Total Signatures
                </div>

                <div className="text-2xl font-semibold">
                  {waiver?.signatureCountForAllVersions}
                </div>

                <Link
                  to={`/business/waivers/signatures/${waiver._id}?versions=all`}
                  className="underline text-sm"
                >
                  View All Signatures
                </Link>
              </div>

            </div>
        </div>
  );
};

export default WaiverHeader;